import { FC } from 'react';

import { FREE_SPACE, MAGNIFYING_GLASS_FRAME_ID, ZOOM_FACTOR } from './constants';
import { MagnifyingGlassFrame, PositioningContainer } from './MagnifyingGlass.styles';
import { useZoomControls } from './ZoomContext';

export const MagnifyingGlass: FC = () => {
    const { x, y, imageToZoomSrc, imageToZoomDimensions, isCursorHovering } = useZoomControls();
    if (
        x === null ||
        y === null ||
        !imageToZoomSrc ||
        !imageToZoomDimensions?.width ||
        !imageToZoomDimensions?.height
    ) {
        return null;
    }

    const zoomX = -1 * (x * ZOOM_FACTOR - FREE_SPACE);
    const zoomY = -1 * (y * ZOOM_FACTOR - FREE_SPACE);

    return (
        <PositioningContainer $isHidden={!isCursorHovering}>
            <MagnifyingGlassFrame id={MAGNIFYING_GLASS_FRAME_ID}>
                <img
                    src={imageToZoomSrc}
                    width={imageToZoomDimensions.width * ZOOM_FACTOR}
                    height={imageToZoomDimensions.height * ZOOM_FACTOR}
                    alt="padidinta nuotrauka"
                    style={{
                        position: 'absolute',
                        left: zoomX,
                        top: zoomY,
                    }}
                />
            </MagnifyingGlassFrame>
        </PositioningContainer>
    );
};
